import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ASSETS_FOLDER } from '../../../../../constants';
import { setCompactVideo } from '../../../../../redux/actions';
import VideoPlayer from '../../../../Shared/VideoPlayer/VideoPlayer';
import './CompactVideo.css';
import { trackEvent } from '../../../../../utils/Stats';

class CompactVideo extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
  }

  // -------------------------------------------------------
  // Events
  // -------------------------------------------------------

  handleClick() {
    this.props.setCompactVideo('');
    trackEvent('btnC', 'close-video');
  }

  handleEnd() {
    this.props.setCompactVideo('');
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { videoId } = this.props;
    return (
      <div id="compact-video">
        <VideoPlayer source={videoId} onEnded={this.handleEnd} />
        <button className="cv-close-btn" onClick={this.handleClick}>
          <img
            src={`${ASSETS_FOLDER}img/scene-compact/btn-back.png`}
            alt=""
          />
        </button>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  setCompactVideo: videoId => dispatch(setCompactVideo(videoId)),
});

export default connect(null, mapDispatchToProps)(CompactVideo);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/SceneCompact/CompactVideo/CompactVideo.js